<template>
    <label v-if="label" class="form-label">{{ label }}</label>
    <div class="row align-items-start g-0">
        <div class="col-md-6">
            <div class="d-flex align-items-center">
                <span class="me-2">De</span>
                <input type="number" class="form-control form-control-sm me-2" min="0" max="255" :value="range.start" @input="updateStart($event.target.value)" />
            </div>
            <div v-if="startError" class="custom-error-msg">{{ startError }}</div>
        </div>
        <div class="col-md-6">
            <div class="d-flex align-items-center">
                <span class="me-2">A</span>
                <input type="number" class="form-control form-control-sm" min="0" max="255" :value="range.end" @input="updateEnd($event.target.value)" />
            </div>
            <div v-if="endError" class="custom-error-msg">{{ endError }}</div>
        </div>
        <div v-if="sizeError" class="custom-error-msg mt-0">{{ sizeError }}</div>
    </div>
</template>

<script>
import Range from '@/models/range';

export default {
    name: 'RangeComponent',
    props: {
        label: {
            type: String,
            default: ''
        },
        range: {
            type: Range,
            required: true
        },
    },
    emits: ['update:range'],
    data() {
        return {
            startError: "",
            endError: "",
            sizeError: "",
        };
    },
    methods: {
        updateStart(value) {
            this.$emit('update:range', 
                new Range(true, Number(value), this.range.end)
            );
        },
        updateEnd(value) {
            this.$emit('update:range', 
                new Range(true, this.range.start, Number(value))
            );
        },
        validate(size, minDiff, maxDiff, sizeError) {
            this.startError = "";
            this.endError = "";
            this.sizeError = "";

            if(this.range.start == 0 || this.range.start > size) {
                this.startError = `Doit être compris entre 1 et ${size}`;
            }
            if(this.range.end == 0 || this.range.end > size) {
                this.endError = `Doit être compris entre 1 et ${size}`;
            }

            if(this.startError || this.endError) return false;

            const diff = this.range.end - this.range.start + 1;
            if(diff < minDiff || diff > maxDiff) {
                this.sizeError = sizeError;
                return false;
            }
            return true;
        },
        reset() {
            this.startError = "";
            this.endError = "";
            this.sizeError = "";
        },
    }
};
</script>

<style scoped>
.custom-error-msg {
    color: red;
    font-size: 14px;
}
</style>
